function About() {
  return <div className="bg-green h-screen">About</div>;
}

export default About;
